import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IPersonnel } from "../IPersonnel";
import { PersonnelEditorViewModel, PersonnelInserter, PersonnelUpdater } from "../personnelEditor/personnelEditor-viewModel";
import  { PersonnelManipulationView } from "./personnelManipulation-view"

export class PersonnelManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تعریف پرسنل';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.personnel = ObservableArray.create<personnel>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh()

    }
    GetDefaultView(): View <ViewModel> {
        return new PersonnelManipulationView();
    }
    public getTypeId(): string {
        return "VM-2123B85D-3602-4FF9-BCBA-1633CCF18072"
    }
    public set personnel(v: ObservableArray<personnel>) { this._personnel = v; } public get personnel(): ObservableArray<personnel> { return this._personnel;} private _personnel: ObservableArray<personnel>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetAllPersonnel',{
                FurtherQueryInfo:filteringInformation
            });
            this.personnel.update(...result.Personnel.map(q=>{
                let r = new personnel(this);
                r.id = q.Id;
                r.address=q.Address;
                r.birthDate=q.BirthDate==null ? null :moment.utc(q.BirthDate);
                r.cellPhone=q.CellPhone;
                r.comment=q.Comment;
                r.fatherName=q.FatherName;
                r.identificationCode=q.IdentificationCode;
                r.isMale=q.IsMale;
                r.lastName=q.LastName;
                r.name=q.Name;
                r.nationalCode=q.NationalCode;
                r.personnelCode=q.PersonnelCode;
                r.paymentInfo=q.PaymentInfo;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new PersonnelEditorViewModel(this,new PersonnelInserter());
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
    async edit(district:IPersonnel){
        let popup = new PersonnelEditorViewModel(this,new PersonnelUpdater());
        district.cloneTo(popup);
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
}

export class personnel extends ViewModel implements IPersonnel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PersonnelManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : PersonnelManipulationViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v:string) {this._name = v; } public get name(): string {return this._name;} private _name:string;    
    public set lastName(v:string) {this._lastName = v; } public get lastName(): string {return this._lastName;} private _lastName:string;    
    public set nationalCode(v:string) {this._nationalCode = v; } public get nationalCode(): string {return this._nationalCode;} private _nationalCode:string;    
    public set personnelCode(v:string) {this._personnelCode = v; } public get personnelCode(): string {return this._personnelCode;} private _personnelCode:string;    
    public set fatherName(v:string) {this._fatherName = v; } public get fatherName(): string {return this._fatherName;} private _fatherName:string;    
    public set identificationCode(v:string) {this._identificationCode = v; } public get identificationCode(): string {return this._identificationCode;} private _identificationCode:string;
    public set birthDate(v:moment.Moment) {this._birthDate = v; } public get birthDate(): moment.Moment {return this._birthDate;} private _birthDate:moment.Moment;
    public set comment(v:string) {this._comment = v; } public get comment(): string {return this._comment;} private _comment:string;
    public set address(v:string) {this._address = v; } public get address(): string {return this._address;} private _address:string;
    public set cellPhone(v:string) {this._cellPhone = v; } public get cellPhone(): string {return this._cellPhone;} private _cellPhone:string;
    public set isMale(v:boolean) {this._isMale = v; } public get isMale(): boolean {return this._isMale;} private _isMale:boolean;
    public set paymentInfo(v: string) { this._paymentInfo = v; } public get paymentInfo(): string { return this._paymentInfo;} private _paymentInfo: string;

    cloneTo(personnel: IPersonnel) {
        personnel.id = this.id;
        personnel.name = this.name;
        personnel.lastName = this.lastName;
        personnel.nationalCode = this.nationalCode;
        personnel.personnelCode = this.personnelCode;
        personnel.fatherName = this.fatherName;
        personnel.identificationCode = this.identificationCode;
        personnel.birthDate = this.birthDate;
        personnel.comment = this.comment;
        personnel.address = this.address;
        personnel.cellPhone = this.cellPhone;
        personnel.isMale = this.isMale;
        personnel.paymentInfo = this.paymentInfo;
    }

    edit(){
        this._typedParent.edit(this);
    }
}